/**
 * Copies text that a component asks for through a `clipboard-copy` event
 * (`detail: {text, label}`) and confirms the result with a toast naming `label`.
 */
export class ClipboardEventAdapter {
  #clipboard;
  #notificationComponent;

  /**
   * @param {{writeText: (text: string) => Promise<void>} | undefined} clipboard usually `navigator.clipboard`,
   *   which is undefined outside a secure context
   * @param {{show: (message: string, type: string) => void}} notificationComponent
   */
  constructor(clipboard, notificationComponent) {
    this.#clipboard = clipboard;
    this.#notificationComponent = notificationComponent;
  }

  connect() {
    document.addEventListener('clipboard-copy', this.#onCopy);
  }

  disconnect() {
    document.removeEventListener('clipboard-copy', this.#onCopy);
  }

  #onCopy = async (event) => {
    const { text, label } = event.detail;
    try {
      await this.#clipboard.writeText(text);
      this.#notificationComponent.show(`${label} copied to the clipboard`, 'success');
    } catch {
      this.#notificationComponent.show(`Could not copy the ${label.toLowerCase()}. Select it and copy it manually.`, 'error');
    }
  };
}
